import { useQuery } from 'react-query';

import api, { QueryConfig } from '@shared/api';

async function getModelsToken(
  { workspaceId }: { workspaceId: string },
  signal: AbortSignal | undefined
): Promise<string> {
  const { data } = await api.post<{ token: string }>(
    'token/mpm/models',
    { workspaceId },
    { signal }
  );

  return data.token;
}

export function useModelsToken(
  { workspaceId }: { workspaceId: string },
  config?: QueryConfig<string>
) {
  return useQuery(
    ['mpm-models-token', { workspaceId }],
    async ({ signal }) => {
      return getModelsToken({ workspaceId }, signal);
    },
    { ...config, enabled: (config?.enabled ?? true) && !!workspaceId }
  );
}
